import React, { useEffect } from 'react';
import { ApplicationState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { getCameraFromList } from '../../../utils';
import { CamerasState } from '../../../store/cameras/types';
import externalImg from '../../../assets/icons/external-link.svg';
import './styles.scss';
import { getLayoutInfo } from "../../../store/layouts/actions";

interface IProps {
  webPageId: string
}

const WebPageComponent: React.FC<IProps> = ({webPageId}) => {
  const {currentCameras} = useSelector<ApplicationState, CamerasState>(state => state.cameras);
  const currentWebPage = Object.values(currentCameras).filter(el => (el && (webPageId === el.id)))[0];
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentCameras) {
      dispatch(getLayoutInfo(webPageId, 'WebPage', currentWebPage?.name));
    }
  }, []);

  if (!currentWebPage) return null;
  const {url, name} = currentWebPage;

  return (
    <div className="pos-rel flex js-c al-it-c w-100 h-100">
      <a href={url} target="_blank" rel="noopener noreferrer" className="open-external">
        <img src={externalImg} alt="Open external"/>
        {name}
      </a>
      <iframe src={url} className="w-100 h-100" title='Web Page'/>
    </div>
  )
};

export default WebPageComponent;